export type SearchStatus = "loading" | "empty" | "has-results" | "error";

export const combineSearchStatus = (
  s1: SearchStatus,
  s2: SearchStatus
): SearchStatus => {
  if (s1 === "loading" || s2 === "loading") {
    return "loading";
  } else if (s1 === "error" || s2 === "error") {
    return "error";
  } else if (s1 === "empty" && s2 === "empty") {
    return "empty";
  } else {
    return "has-results";
  }
};
